export default __webpack_public_path__ + "static/media/scripps_pier.75e1281f.jpeg";